<template>
  <div class="travel_invitation">
    <!-- 活动标题 -->
    <div v-wechat-title='"时光旅行社-开业邀请函"'></div>

    <div class="invitation-help-page">

    <header :class="'header-login-' + headerLogin">
      <div class="acco">{{ isUserInfo.account }}</div>
      <a class="download-btn" :href="downloadUrl" title="下载按钮"></a>
      <a v-if="isUserInfo.account == ''" class="logon-btn" @click="logon()" title="登录&切换按钮" href="javascript:;"></a>
      <a v-else href="javascript:;" class="switch-btn" @click="switchBtn()"></a>
    </header>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:channelCallback='selectCallback'
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      :autoOpenOS="false"
      channelTips="角色ID可在游戏中—信息查看"></Login>
    <Os v-if='isShowOs'
      v-on:selectCallback='selectCallback'
      v-on:logoutCallback='osCancell'
      :gameName="gameName"></Os>

    <div class="help-page">
      <div class="page-1" title="贺卡">
          <div class="role"></div>
          <div class="invitation-envelope"></div>
          <div class="bg">
            <div class="flower-top"></div>
            <div class="flower-bottom"></div>
            <div :class="'wrap-btn wrap-btn-'+isActivity.is_get" @click="receiveCode()"><a href="javascript:;" ></a></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 领取成功弹窗 -->
    <div class="success-wrap popup_wrap" v-show="successShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="success-box popup_wrap-box" v-show="successShow">          
          <b class="close-btn" @click="successShow = false"></b>
        </div>
      </transition>
      <div class="close-bg" @click="successShow = false"></div>
    </div>

    <!-- 注销弹窗 -->
    <div class="logout-wrap popup_wrap" v-show="logoutShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="logout-box popup_wrap-box" v-show="logoutShow">
          <p>是否退出当前账号</p>
          <a class="left-btn" href="javascript:;" @click="logoutShow = false">取消</a>
          <a class="right-btn" href="javascript:;" @click="logoutBtn()">确定</a>
        </div>
      </transition>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import { onHelpGetInitDataAPI, onLogoutApi, onHelpFriendRewardsAPI } from '../api';
import { getTimeStamp, buriedLogger, getRandomString, analysisParams } from '@/utils/utils';
export default {
  name: 'lottery',
  components: {
    Login,
    Os,
  },
  data () {
    return {
      gameName: 'travel',
      logger: null,
      downloadUrl: 'http://sglxs.qingcitimes.com/',
      // 其他数据
      loginTypes: ['sms', 'password'],
      preventShow: false,
      is_access_token: '',
      headerLogin: false,
      logoutShow: false,
      successShow: false,
      code_id: '',

      isActivity: {
        is_get: '',
        is_bind: '',
        is_my: '',
        is_reward_start: '',
        is_running: '',
        is_vip: '',
        platform: '',
        record_list: [],
        role_id: '',
        role_name: '',
        server_id: '',
        server_name: '',
        user_id: '',
      },
      isUserInfo: {
        account: '',
      },
    };
  },
  created () {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    

    const { protocol, host } = window.location;
    const params = analysisParams(window.location.href);
    this.code_id = params.code_id;
    
    // 帮助页面初始化
    this.onHelpIntState();

    // 埋点
    const bl = buriedLogger('travel', '时光电子邀请函_助力页');
    this.logger = bl;

    this.isSetShare();
  },
  mounted () {
    this.$nextTick(() => {
      this.monitoringEquipment();
    })
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        console.log('newValue', newValue);
        console.log('oldValue', oldValue);
        if (!newValue.account) {
          // TAG: 注销的时候
        } else if (newValue.account !== oldValue.account) {
          // TAG: 初始登陆/切换角色的时候
          this.onHelpIntState();
        }
      }
    }
  },
  methods: {
    monitoringEquipment () {
      const { protocol, host } = window.location;
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = `${protocol}//${host}/travel/invitation/pc${getTimeStamp()}`
    },
    // 登录弹窗
    logon() {
      this.changeLoginPopup(true);
      this.logger.sum('时光旅行社_vip电子邀请函H5_点击头部登录按钮');
    },
    switchBtn() {
      this.logoutShow = true;
      this.logger.sum('时光旅行社_vip电子邀请函H5_点击头部切换录按钮');
    },
    onHelpIntState() {
      this.is_access_token = localStorage.getItem('access_token');
      onHelpGetInitDataAPI({code: this.code_id, access_token: this.is_access_token}).then(response => {
        const { code } = response || {}
        if (Number(code) === 200) {
          this.setActivity(response.data.activity);
          this.setUserinfo(response.data.user_info);
          this.logger.sum('时光旅行社_vip电子邀请函H5_帮助页面_初始化');
          return
        }
        if (Number(code) === 401) {
          this.changeLoginPopup(true);
          return      
        }
        if (Number(code) === 403) {
          this.changeLoginPopup(true);
          return      
        }
        this.onToast(response.message);
      });
    },
    // 活动内容
    setActivity(data) {
      this.isActivity = data;      
      this.headerLogin = true;
    },
    // 个人信息
    setUserinfo(data) {
      this.isUserInfo = data;
    },
    // 领取code码
    receiveCode() {
      if(this.preventShow == false) {
        this.preventShow = true;
      }
      setTimeout(() => {  this.preventShow = false }, 2500);
      if(this.isActivity.is_get == true) {
        this.onToast('您已领取奖励，无需重复领取');
        return
      }
      if (this.isUserInfo.account === undefined || this.isUserInfo.account === '') {
        this.changeLoginPopup(true);
        return
      }
      if(this.isActivity.is_my == true) {
        this.onToast('非常抱歉，不能领取自己的奖励');
        return
      }

      if(this.isActivity.is_vip == 1) {
        this.onToast('您为尊贵的VIP3用户，请前往VIP3邀请函页面领取');
        setTimeout(() => {
          location.href = 'https://qcg.ink/wSN6g2';
        }, 1000);
        return
      }
      // 好友领取分享的奖励
      this.selectCallback();
    },
    // 账号注销按钮
    logoutBtn() {
      onLogoutApi().then(response => {
        const { code } = response || {}
        if (Number(code) === 200) {
          this.headerLogin = false;
          this.logoutShow = false;
          this.clearData();
        }
      });
    },
    // 数据清除
    clearData() {
      Object.keys(this.isActivity).forEach(key=>{this.isActivity[key]=''});
      Object.keys(this.isUserInfo).forEach(key=>{this.isUserInfo[key]=''});
      window.localStorage.clear();
    },
    // 选择角色后
    selectCallback () {  
      this.preventShow = false;    
      // 好友领取分享的奖励
      onHelpFriendRewardsAPI({code: this.code_id, access_token: this.is_access_token}).then(response => {
        const { code } = response || {}
        if (Number(code) === 200) {
          this.isActivity.is_get = true;
          this.successShow = true;          
          this.logger.sum('时光旅行社_vip电子邀请函H5_帮助页面_vip3挚友携行礼包领取成功');
          return
        }
        if (Number(code) === 403) {
          this.changeLoginPopup(true);
          return
        }
        if (Number(code) === 407) {
          this.onToast(response.message);
          this.onHelpIntState();
          return
        }
        if (Number(code) === 406) {
          this.onToast(response.message);
          location.href = 'https://qcg.ink/wSN6g2';
          return
        }
        if (Number(code) === 408) {
          this.setUserInfo(this.isUserInfo);
          this.changeOsPopup(true);
          return
        }
        this.onToast(response.message);
      });
    },
    // 区组弹窗注销-相关参数复位
    osCancell () {
      this.headerLogin = false;
      this.logoutShow = false;
      this.clearData();
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 微信分享
    isSetShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/travel/invitation/enter${getRandomString()}`,
        title: '时光旅行社贵宾邀请函',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/aFRAFaBaBj7IP3W7Iq9QFrI1w5HjzAqLpo3vZLPL.png',
        desc: '尊敬的青瓷VIP3用户，时光旅行社现已开业，诚邀您光临~'
      })
    },
    ...mapMutations([
      "setUserInfo",
      'setInitUserInfo',
      'setInitActiveInfo',
      'changeLoginPopup',
      'changeOsPopup'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'onCount',
      'setShare'
    ])

  }
};
</script>

<style lang='less'>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/travel/invitation/help/index.vue